/**
* jv.candDetailsActivity Module
*
* Description
*/
angular.module('jv.candidate.details.activity.controller', [])
    .controller('jvCandDetailsActivityController', ['$scope', '$routeParams', '$filter', 'candidates', '$window',
        function($scope, $routeParams, $filter, candidates, $window){
            $scope.flags.loading=true;
            $scope.activities = {};
            $scope.activities.list = [];
            $scope.activities.count = 0;
            $scope.activities.limit = 20;
            $scope.activities.pageIndex = 0;
            $scope.activities.currentPageIndex = 0;
            $scope.activities.displayHeight = 800;

            var properties = $window.properties;
            properties.auditLogUIEnabled = $window.properties.auditLogUIEnabled || $scope.params.testAuditUI;
            $scope.properties = properties;
            $scope.url = '/jhire/action/application/'+$routeParams.applicationId+'/auditLogs';

            $scope.action = function(EId, type) {
                $scope.doAction(EId, type);
            };

            $scope.getActivityFeed = function(start){
                candidates.getActivityFeed($routeParams.applicationId, $scope.activities.limit, start, function(res){
                    if(res.feedContent && res.feedContent.resultList){
                        for(var i=0; i<res.feedContent.resultList.length; i++){
                            var activityObj = res.feedContent.resultList[i];
                            $scope.createMsg(activityObj);
                            $scope.createAction(activityObj);
                        }
                        $scope.activities.list = (start === 0) ? res.feedContent.resultList : $scope.activities.list.concat(res.feedContent.resultList);
                        $scope.activities.count = res.feedContent.resultCount;
                    }
                    $scope.flags.loading=false;
                });
            };

            if (!$scope.properties.auditLogUIEnabled) {
                $scope.getActivityFeed(0);
            } else {
                $scope.flags.loading = false;
            }

            $scope.createMsg = function(activityObj){
                activityObj.msg = i18n[activityObj.message];
                for(var j=0; j<activityObj.customProperties.length; j++){
                    var temp = {};
                    temp[activityObj.customProperties[j].name.trim()] = activityObj.customProperties[j].value ? activityObj.customProperties[j].value.trim() : '';
                    var parsedDateTime = parseFloat(temp.Interview_Date_Time);
                    if(temp.Interview_Date_Time && parsedDateTime) {
                        temp.Interview_Date_Time = $filter('localeDateTime')(parsedDateTime, 'longTimestamp', 'MMMM dd, yyyy HH:mm:ss');
                    }
                    activityObj.msg = $scope.format(activityObj.msg, temp);
                    activityObj.msg = activityObj.msg.replace(/\(\)+/g,'');

                    var innerValue = i18n[activityObj.customProperties[j].value];

                    if(innerValue)
                    {
                        activityObj.msg = activityObj.msg.replace(new RegExp(activityObj.customProperties[j].name.trim(),'g'), ':'+activityObj.customProperties[j].name.trim());
                        var innerTmp = {};
                        innerTmp[activityObj.customProperties[j].name.trim()] = innerValue;
                        activityObj.msg = $scope.format(activityObj.msg, innerTmp);
                    }
                }
            };

            $scope.createAction = function(activityObj){
                activityObj.doAction = [];
                for(var j=0, k=0; j<activityObj.actions.length; j=j+3, k++){
                    activityObj.doAction[k] = {};
                    activityObj.doAction[k]['type'] = activityObj.actions[j].value || '';
                    activityObj.doAction[k]['name'] = activityObj.actions[j+1].value || '';
                    activityObj.doAction[k]['value'] = activityObj.actions[j+2].value || '';
                }
            };

            $scope.nextFeeds = function(){
                if($scope.activities.pageIndex === $scope.activities.currentPageIndex){
                    $scope.activities.currentPageIndex++;
                    $scope.getActivityFeed($scope.activities.list.length);
                }
                $scope.activities.pageIndex++;
            };

            $scope.hasNext = function(){
                if(($scope.activities.currentPageIndex+1)*$scope.activities.limit > $scope.activities.count){
                    return false;
                }
                return true;
            };
    }]);
